import { Breadcrumb, Col, Form, Input, Pagination, Row, Select, Space, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLazyGetProcedureListQuery } from "../redux/ProcedureApi";
import { ReactComponent as Search } from '../../../assets/images/Search.svg'
import { ArrowRightOutlined } from "@ant-design/icons";

const { Option } = Select;

const ProcedureList = () => {
    const [form] = Form.useForm();
    const [trigger, response] = useLazyGetProcedureListQuery();
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [searchTitle, setSearchTitle] = useState("");
    const divRef = useRef<HTMLDivElement>(null);

    const navigate = useNavigate();

    useEffect(() => {
        scrollIntoView();
    }, [page, size, searchTitle])

    useEffect(() => {
        trigger({ page: 0, size: 10, title: "", status: 1 }).unwrap().then(res => {
            scrollIntoView();
        })
    }, [trigger])

    const scrollIntoView = () => {
        if (divRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const searchProcedures = (currentPage: number, currentSize: number, currentTitle: string) => {
        trigger({ page: currentPage - 1, size: currentSize, title: currentTitle, status: 1 })
    }

    const changePage = (currentPage: number) => {
        setPage(currentPage);
        searchProcedures(currentPage, size, searchTitle);
    }

    const changeSize = (currentSize: number) => {
        setSize(currentSize);
        setPage(1);
        searchProcedures(1, currentSize, searchTitle);
    }

    const onFinish = (values: any) => {
        setSearchTitle(values.title);
        setPage(1);
        searchProcedures(1, size, values.title);
    }

    return (
        <div
            ref={divRef}
            style={{
                // padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%',
                paddingTop: 40,
                paddingBottom: 40,
            }}
        >
            <div className="responsive-padding-1440" style={{ marginTop: -140, marginBottom: 60 }}>
                <Form
                    initialValues={{ title: searchTitle }}
                    form={form}
                    onFinish={onFinish}
                >
                    <Form.Item name="title" style={{ marginBottom: 0 }}>
                        <Input
                            style={{ marginTop: 0 }}
                            className="search-bar"
                            placeholder="Nhập tiêu đề hướng dẫn muốn tìm"
                            suffix={<Search style={{ cursor: 'pointer' }} onClick={() => form.submit()} />}
                            maxLength={200} />
                    </Form.Item>
                </Form>
            </div>
            <div style={{ display: 'flex', alignItems: "center", justifyContent: "space-between" }} className="responsive-padding-1440">
                <Space style={{ display: 'flex', alignItems: 'center' }}>
                    <Breadcrumb separator="  " className="custom-breadcrumb" style={{ paddingLeft: 0 }}>
                        <Breadcrumb.Item>
                            <Link to="/">
                                Trang chủ
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            Thủ tục đấu giá
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Typography.Text ellipsis className="responsive-title">Hướng dẫn thủ tục đấu giá tài sản</Typography.Text>
                </Space>
            </div>

            <div className="responsive-padding-1440" style={{ marginTop: 50 }}>
                <Row align="middle" justify="center">
                    <Col span={24}>
                        {response.data?.content?.length ? response.data?.content.map(item => {
                            return (
                                <Row
                                    title={item.title}
                                    style={{
                                        borderRadius: 15,
                                        background: 'white',
                                        maxHeight: 90,
                                        padding: '15px 30px',
                                        fontSize: 20,
                                        marginBottom: 10
                                    }}
                                    align='middle'
                                    key={item.id}
                                    className="custom-card-hover cursor-pointer"
                                    onClick={() => navigate(`/procedure/${item.id}`)}
                                >
                                    <Col span={23} className="custom-text-overflow-2">
                                        {item.title}
                                    </Col>
                                    <Col span={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <ArrowRightOutlined />
                                    </Col>
                                </Row>
                            )
                        })
                            :
                            <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                                Không có bản ghi nào
                            </p>
                        }
                    </Col>
                </Row>
                <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Select className="left-arrow-select" defaultValue={10} value={size} onChange={changeSize} dropdownStyle={{ borderRadius: 15 }}>
                        <Option value={10}>10</Option>
                        <Option value={20}>20</Option>
                        <Option value={50}>50</Option>
                        <Option value={100}>100</Option>
                    </Select>
                    <div
                        style={{
                            marginRight: 20,
                            marginLeft: 8,
                            fontSize: 14
                        }}
                    >
                        Trong tổng số <span className="font-bold">{response.data?.totalElements || 0}</span> bản ghi
                    </div>
                    <Pagination
                        total={response.data?.totalElements || 0}
                        defaultCurrent={1}
                        defaultPageSize={10}
                        current={page}
                        pageSize={size}
                        onChange={changePage}
                        className="custom-pagination"
                    />
                </div>
            </div>
        </div>
    )

}

export default ProcedureList;